<template>
    <CRow v-show="mostrarCarga">
        <CCol md="12">
            <center>
                <img src="/img/logo2.png" size="custom-size" :height="height" class="imgr mt-3 mb-3" /> {{ mensajeInfo }}
            </center>
        </CCol>
    </CRow>

  
</template>
<script>

    import { freeSet } from "@coreui/icons";

    export default {
        name: "CargandoInfo",
        freeSet,
        props: {
            mostrarCarga: Boolean,
            mensajeInfo: String,
            height: {
                type: Number,
                default: 50
            }
        },
        components: { },
        data() {
            return { };
        },
        created: function () { },
        beforeMount() { },
        methods: { },
    };
</script>